import { useState, useEffect, useContext } from "react";
import GlobalStyles from "@mui/material/GlobalStyles";

import { DataContext } from 'providers/data';
import { ParamsDataFinancialPending } from 'utils/typeServices';

import {
    Box,
    Table,
    Button,
    TableRow,
    TableCell,
    TableBody,
    TableHead,
    Typography,
    TableContainer,
    Collapse,
} from '@mui/material';

import ContentForgot from 'components/views/ContentForgot';
import PayInvoiceExternal from 'components/views/PayInvoiceExternal';

import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import { ModalPaymentMethodTicket, ModalPaymentMethodTicketConfirm } from 'components/views/Invoices/Modals';

import BackgroundForgotLogin from 'assets/images/background-forgot-login.png';

import { ButtonCustom, TypographyLabel, TypographyText, ContainerRowNav, ButtonCustomDesk, BoxContent, TableCellBody } from './styles';

type ParamsDetails = {
    DT_EMISSAO: string;
    DT_VENCIMENTO: string;
    VL_ORIGINAL: string;
    VL_ATUALIZADO: string;
    NM_TIPO_COBRANCA: string;
    overdueInv: boolean;
    onClickReturn: (value: boolean) => void;
}

const dataInvoice = [
    'Status',
    'Vencimento',
    'Emissão',
    'Valor',
    'Tipo de Cobrança'
];

const ContentDetails = ({ DT_EMISSAO, DT_VENCIMENTO, VL_ORIGINAL, VL_ATUALIZADO, NM_TIPO_COBRANCA, overdueInv, onClickReturn }: ParamsDetails) => {
    const [showDetails, setShowDetails] = useState(false);

    return (
        <Box sx={{ marginBottom: '1rem' }}>
            <Box sx={{
                padding: '.2rem .75rem',
                borderRadius: '5px',
                backgroundColor: overdueInv ? 'rgba(255, 0, 0, 0.1)' : 'transparent'
            }}>
                <ContainerRowNav style={{ gridTemplateColumns: '1fr 1fr 1fr', gap: '1rem', width: '100%' }}>
                    <Box>
                        <TypographyLabel>
                            Vencimento
                        </TypographyLabel>
                        <TypographyText fontWeight={400} paddingTop='.25rem'>
                            {DT_VENCIMENTO}
                        </TypographyText>
                    </Box>
                    <Box>
                        <TypographyLabel>
                            Emissão
                        </TypographyLabel>
                        <TypographyText fontWeight={400} paddingTop='.25rem'>
                            {DT_EMISSAO}
                        </TypographyText>
                    </Box>
                    <Box>
                        <TypographyLabel>
                            Valor
                        </TypographyLabel>
                        <Typography variant='subtitle2' fontWeight={700} paddingTop='.25rem'>
                            {VL_ATUALIZADO}
                        </Typography>
                        <Typography fontSize='.5625rem' lineHeight='.7rem' paddingTop='.2rem'>
                            Valor original - {VL_ORIGINAL}
                        </Typography>
                    </Box>
                </ContainerRowNav>
                <Box>
                    <Collapse in={showDetails}>
                        <Box sx={{ marginTop: '1rem', display: 'grid', gridTemplateColumns: '1fr 1fr', alignItems: 'start' }}>
                            <Box>
                                <TypographyLabel>
                                    Tipo de Cobrança
                                </TypographyLabel>
                                <TypographyText fontWeight={400} paddingTop='.25rem'>
                                    {NM_TIPO_COBRANCA}
                                </TypographyText>
                            </Box>
                            <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'flex-start' }}>
                                <ButtonCustom
                                    variant='contained'
                                    color='secondary'
                                    sx={{
                                        minWidth: '7.125rem',
                                        height: '2.5rem',
                                        padding: '0.5rem 1rem',
                                        fontSize: '0.75rem',
                                        fontWeight: 600,
                                        whiteSpace: 'nowrap'
                                    }}
                                    onClick={() => onClickReturn(true)}
                                >
                                    PAGAR AGORA
                                </ButtonCustom>
                            </Box>
                        </Box>
                    </Collapse>
                    <Box sx={{
                        display: 'flex',
                        position: 'relative',
                        alignItems: 'center',
                        margin: `1.4rem 0 ${overdueInv ? '1rem' : '0'}`,
                        justifyContent: 'center',
                        borderBottom: overdueInv ? '1px solid rgba(141, 155, 181, 0.35)' : 'none'
                    }}>
                        <Button sx={{
                            width: '3.875rem',
                            height: '1.25rem',
                            paddingTop: '8px',
                            fontSize: '.5625rem',
                            borderRadius: '10px',
                            border: '1px solid #8D9BB5',
                            position: 'absolute',
                            backgroundColor: 'white',
                            '&:hover': {
                                backgroundColor: 'white',
                            }
                        }}
                            onClick={() => setShowDetails(!showDetails)}
                        >
                            {showDetails ? 'FECHAR' : 'DETALHES'}
                        </Button>
                    </Box>
                </Box>
            </Box>
        </Box>
    );
}

const Pending = () => {
    const date = new Date();
    const [payInvoice, setPayInvoice] = useState(false);
    const [indexFinancialPendingSelected, setIndexFinancialPendingSelected] = useState(0);
    const [showModalPaymentMethodTicket, setShowModalPaymentMethodTicket] = useState(false);
    const [showModalPaymentMethodTicketConfirm, setShowModalPaymentMethodTicketConfirm] = useState(false);
    const [dataFinancialPendingSelected, setDataFinancialPendingSelected] = useState<ParamsDataFinancialPending>();
    const [dataFinancialPendingState, setDataFinancialPendingState] = useState<Array<ParamsDataFinancialPending>>();
    const [termAcceptanceDate, setTermAcceptanceDate] = useState<string | null>(null);
    date.setDate(date.getDate() - 1);

    const { dataFinancialPending, handlePostGenerateBilling, handlePostListarFormaPagamentoPorCanalVenda } = useContext(DataContext);

    const formatTermAcceptanceDate = (dateString: string) => {
        const date = new Date(dateString);
        return date.toLocaleDateString('pt-BR', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric'
        });
    };

    const handleValidateStatus = (datePayment: string) => {
        const datePaymentAux = datePayment.split('/');

        if (datePaymentAux && date) {
            const datePaymentMonthly = new Date(`${datePaymentAux[1]}-${datePaymentAux[0]}-${datePaymentAux[2]}`);
            if (date.getTime() >= datePaymentMonthly.getTime()) {
                return true;
            } else {
                return false;
            }
        }
        return false;
    }

    const handlePayInvoice = (index: number, noValidate?: boolean) => {
        setIndexFinancialPendingSelected(index);

        if (Array.isArray(dataFinancialPendingState)) {
            if ((dataFinancialPendingState[index]?.ID_FORMA_PGTO !== 22) || noValidate) {
                setDataFinancialPendingSelected(dataFinancialPendingState[index]);

                handlePostListarFormaPagamentoPorCanalVenda({
                    token: '',
                    body: { CdCanalVenda: 81, CdTipoCobranca: dataFinancialPendingState[index].CD_TIPO_COBRANCA }
                })
                handlePostGenerateBilling({
                    token: '',
                    body: { CHAVE_PAGAMENTO: dataFinancialPendingState[index]?.CHAVE_PAGAMENTO!, CD_FORMA_PAGAMENTO: dataFinancialPendingState[index]?.CD_FORMA_PAGAMENTO! },
                    type: 'ticket'
                });
                handlePostGenerateBilling({
                    token: '',
                    body: { CHAVE_PAGAMENTO: dataFinancialPendingState[index]?.CHAVE_PAGAMENTO!, CD_FORMA_PAGAMENTO: dataFinancialPendingState[index]?.CD_FORMA_PAGAMENTO! },
                    type: 'pix'
                });

                setPayInvoice(true);
            } else {
                setShowModalPaymentMethodTicket(true);
            }
        }
    }

    useEffect(() => {
        if (Array.isArray(dataFinancialPending) && dataFinancialPending.length > 0) {
            setDataFinancialPendingState(dataFinancialPending);
        } else if (dataFinancialPending && typeof dataFinancialPending === 'object' && !Array.isArray(dataFinancialPending)) {
            // Verificar se existe termo aceito na resposta
            const responseData = dataFinancialPending as any;
            if (responseData?.Data?.TermoIturanHub?.DtAceiteTermo) {
                setTermAcceptanceDate(responseData.Data.TermoIturanHub.DtAceiteTermo);
            }
            if (responseData?.Data?.Cobrancas) {
                setDataFinancialPendingState(responseData.Data.Cobrancas);
            }
        }
    }, [dataFinancialPending]);

    return (
        <ContentForgot background={BackgroundForgotLogin} titleNav="Cobranças em aberto">
            <GlobalStyles
                styles={{
                    'iframe[title="Mensagem da empresa"]': {
                        display: 'none !important',
                        opacity: '0 !important'
                    },
                    'iframe[title = "Fechar mensagem"]': {
                        display: 'none !important',
                        opacity: '0 !important'
                    },
                    'iframe[title="Close message"]': {
                        display: 'none !important',
                        opacity: '0 !important'
                    },
                    'iframe[title="Company message"]': {
                        display: 'none !important',
                        opacity: '0 !important'
                    },
                    'iframe[title="Message from company"]': {
                        display: 'none !important',
                        opacity: '0 !important'
                    },
                    '#launcher': {
                        display: 'none'
                    }
                }}
            />
            <Box sx={{ height: '100%', overflow: { xs: 'auto', md: 'hidden' }, margin: 'auto', padding: { xs: '3.6rem 0 1rem', md: '.5rem 0 0', lg: '4rem 0 0' }, width: '100%', maxWidth: '45rem' }}>
                <Collapse in={payInvoice} {...(payInvoice ? { timeout: 800 } : {})}>
                    <BoxContent sx={{
                        width: '100%',
                        padding: { xs: '0rem 1.6875rem 2.375rem', md: '1.375rem 1.6875rem 1.56rem', lg: '1.375rem 1.6875rem 2.375rem' },
                        border: {
                            xs: 'none',
                            md: '1.5px solid rgba(12, 28, 51, 0.5)'
                        }
                    }}>
                        <Box sx={{
                            width: '100%',
                            marginBottom: {
                                xs: '1.64rem',
                                md: '1rem',
                                lg: '1.64rem'
                            },
                            paddingBottom: '.56rem',
                            borderBottom: '1px solid rgba(141, 155, 181, 0.5)',
                        }}>
                            <Box sx={{ display: 'flex', alignItems: 'flex-end', gap: '.4375rem', cursor: 'pointer' }} onClick={() => setPayInvoice(false)}>
                                <Box sx={{
                                    width: '1.5rem',
                                    height: '1.5rem',
                                    borderRadius: '2px',
                                    display: 'flex',
                                    padding: '.15rem 0',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    border: '1px solid #0C1C33',
                                    'svg': {
                                        fill: '#0C1C33'
                                    }
                                }}>
                                    <ArrowBackIosNewIcon sx={{
                                        height: '100%'
                                    }} />
                                </Box>
                                <Typography fontSize='1.25rem' fontWeight={700} color='primary.main' lineHeight='1'>
                                    Pagamento
                                </Typography>
                            </Box>
                        </Box>
                        {dataFinancialPendingSelected &&
                            <PayInvoiceExternal financialPendingSelected={dataFinancialPendingSelected} handleChangeReturn={() => setPayInvoice(false)} />
                        }
                    </BoxContent>
                </Collapse>

                <Collapse in={!payInvoice} {...(!payInvoice ? { timeout: 800 } : {})}>
                    <BoxContent sx={{
                        height: '100%',
                        width: 'fit-content',
                        padding: { xs: '0rem', md: '2.375rem 1.6875rem' },
                        border: {
                            xs: 'none',
                            md: '1.5px solid rgba(12, 28, 51, 0.5)'
                        }
                    }}>
                        <Typography fontSize='1.5625rem' marginBottom='2rem' fontWeight={700} sx={{ display: { xs: 'none', md: 'flex' } }}>
                            Cobranças em aberto
                        </Typography>

                        <Box sx={{
                            height: '100%',
                            maxHeight: { xs: '100%', md: 'calc(100vh - 18.5rem)' },
                            overflow: 'auto'
                        }}>
                            <TableContainer sx={{
                                overflowX: 'inherit',
                                display: {
                                    xs: 'none',
                                    md: 'block'
                                }
                            }}>
                                <Table aria-label="simple table" sx={{ position: 'relative' }}>
                                    <TableHead>
                                        <TableRow>
                                            {dataInvoice.map((title, index) =>
                                                <TableCell key={index} sx={{ border: 'none', padding: '0 0 .35rem' }}>
                                                    <Typography
                                                        fontSize='.75rem'
                                                        color='primary.main'
                                                        fontWeight={600}
                                                        lineHeight='1rem'
                                                        sx={{
                                                            padding: '.25rem 0 0 .25rem',
                                                            borderBottom: '1px solid rgba(141, 155, 181, 0.35)',
                                                        }}>
                                                        {title}
                                                    </Typography>
                                                </TableCell>
                                            )}
                                            <TableCell sx={{ border: 'none', padding: '0 0 .35rem' }}>
                                                <Typography>
                                                    &nbsp;
                                                </Typography>
                                            </TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <Box sx={{ width: '100%', display: 'flex', height: '.2rem' }} />
                                    {dataFinancialPendingState?.map(({ DT_EMISSAO, DT_VENCIMENTO, VL_ORIGINAL, VL_ATUALIZADO, NM_TIPO_COBRANCA, NR_STATUS }, index) =>
                                        <TableBody key={index} sx={{ position: 'relative' }}>
                                            <Box sx={{ width: '100%', display: 'flex', height: '.3rem' }} />
                                            <TableRow>
                                                <TableCellBody sx={{ borderRadius: '4px 0 0 4px', backgroundColor: handleValidateStatus(DT_VENCIMENTO) ? 'rgba(255, 0, 0, 0.1)' : 'transparent' }}>
                                                    <Typography
                                                        fontWeight={700}
                                                        fontSize='.75rem'
                                                        color={handleValidateStatus(DT_VENCIMENTO) ? '#FF0000' : '#0AA8E3'}
                                                        lineHeight='1rem'
                                                        sx={{
                                                            minWidth: '5rem',
                                                            padding: '.25rem 0 0 .6rem',
                                                        }}
                                                    >
                                                        {handleValidateStatus(DT_VENCIMENTO) ? 'VENCIDA' : 'A VENCER'}
                                                    </Typography>
                                                </TableCellBody>
                                                <TableCellBody sx={{ backgroundColor: handleValidateStatus(DT_VENCIMENTO) ? 'rgba(255, 0, 0, 0.1)' : 'transparent' }}>
                                                    <Typography
                                                        fontSize='.75rem'
                                                        lineHeight='1rem'
                                                        sx={{
                                                            minWidth: '6rem',
                                                            padding: '.25rem 0 0 .3rem',
                                                        }}
                                                    >
                                                        {DT_VENCIMENTO}
                                                    </Typography>
                                                </TableCellBody>
                                                <TableCellBody sx={{ backgroundColor: handleValidateStatus(DT_VENCIMENTO) ? 'rgba(255, 0, 0, 0.1)' : 'transparent' }}>
                                                    <Typography
                                                        fontSize='.75rem'
                                                        lineHeight='1rem'
                                                        sx={{
                                                            minWidth: '6rem',
                                                            padding: '.25rem 0 0 .3rem',
                                                        }}
                                                    >
                                                        {DT_EMISSAO}
                                                    </Typography>
                                                </TableCellBody>
                                                <TableCellBody sx={{ backgroundColor: handleValidateStatus(DT_VENCIMENTO) ? 'rgba(255, 0, 0, 0.1)' : 'transparent' }}>
                                                    <Typography
                                                        fontWeight={700}
                                                        fontSize='.875rem'
                                                        color='primary.main'
                                                        lineHeight='1rem'
                                                        textTransform='capitalize'
                                                        sx={{
                                                            minWidth: '6rem',
                                                            padding: '.25rem 0 0 .3rem',
                                                        }}
                                                    >
                                                        { VL_ATUALIZADO || '' }
                                                    </Typography>
                                                    <Typography fontSize='.5625rem' lineHeight='.7rem' sx={{
                                                        padding: '.1rem 0 0 .3rem',
                                                    }}>
                                                        Valor original<br />
                                                        {VL_ORIGINAL}
                                                    </Typography>
                                                </TableCellBody>
                                                <TableCellBody sx={{ backgroundColor: handleValidateStatus(DT_VENCIMENTO) ? 'rgba(255, 0, 0, 0.1)' : 'transparent' }}>
                                                    <Typography
                                                        fontSize='.75rem'
                                                        lineHeight='1rem'
                                                        sx={{
                                                            minWidth: '7.5rem',
                                                            maxWidth: '8rem',
                                                            padding: '.25rem 0 0 .3rem',
                                                        }}
                                                    >
                                                        {NM_TIPO_COBRANCA}
                                                    </Typography>
                                                </TableCellBody>
                                                <TableCellBody sx={{ borderRadius: '0 4px 4px 0', backgroundColor: handleValidateStatus(DT_VENCIMENTO) ? 'rgba(255, 0, 0, 0.1)' : 'transparent' }}>
                                                    <Box sx={{ paddingRight: '.6rem', }}>
                                                        {NR_STATUS !== 3 &&
                                                            <ButtonCustomDesk
                                                                variant='contained'
                                                                color='secondary'
                                                                sx={{
                                                                    minWidth: '7rem',
                                                                    height: '2.5rem',
                                                                    padding: '0.5rem 1rem',
                                                                    fontSize: '0.75rem',
                                                                    fontWeight: 600,
                                                                    whiteSpace: 'nowrap'
                                                                }}
                                                                onClick={() => handlePayInvoice(index)}
                                                            >
                                                                PAGAR AGORA
                                                            </ButtonCustomDesk>
                                                        }
                                                    </Box>
                                                </TableCellBody>
                                            </TableRow>
                                        </TableBody>
                                    )}
                                </Table>
                            </TableContainer>
                            {!dataFinancialPendingState &&
                                <Typography
                                    fontSize='1rem'
                                    fontWeight={700}
                                    paddingTop='1.75rem'
                                    color='primary.main'
                                >
                                    Sem faturas disponíveis.
                                </Typography>
                            }
                        </Box>

                        <Box sx={{
                            display: {
                                xs: 'block',
                                md: 'none'
                            }
                        }}>


                            {dataFinancialPendingState?.map(({ DT_EMISSAO, DT_VENCIMENTO, VL_ORIGINAL, VL_ATUALIZADO, NM_TIPO_COBRANCA }, index) =>
                                <ContentDetails
                                    key={index}
                                    DT_EMISSAO={DT_EMISSAO}
                                    DT_VENCIMENTO={DT_VENCIMENTO}
                                    VL_ORIGINAL={VL_ORIGINAL}
                                    VL_ATUALIZADO={VL_ATUALIZADO}
                                    NM_TIPO_COBRANCA={NM_TIPO_COBRANCA}
                                    overdueInv={handleValidateStatus(DT_VENCIMENTO)}
                                    onClickReturn={e => handlePayInvoice(index)}
                                />
                            )}
                        </Box>
                    </BoxContent>
                </Collapse>

                {/* Mensagem do termo aceito - fora do modal */}
                {termAcceptanceDate && (
                    <Box sx={{
                        width: '100%',
                        maxWidth: '45rem',
                        margin: '1.5rem auto 0',
                        padding: '0 1rem'
                    }}>
                        <Typography
                            fontSize='0.6875rem'
                            color='#666666'
                            fontWeight={400}
                            sx={{
                                textAlign: 'center',
                                lineHeight: 1.2
                            }}
                        >
                            • Termo de adesão lido e aceito pelo cliente em <Box component="span" sx={{ fontWeight: 700 }}>{formatTermAcceptanceDate(termAcceptanceDate)}</Box>.
                        </Typography>
                    </Box>
                )}
            </Box>
            <ModalPaymentMethodTicket open={showModalPaymentMethodTicket} handleClick={(e) => {
                if (e) {
                    setShowModalPaymentMethodTicketConfirm(e);
                }
                setShowModalPaymentMethodTicket(false);
            }} />
            <ModalPaymentMethodTicketConfirm open={showModalPaymentMethodTicketConfirm} handleClick={(e) => {
                if (e) {
                    handlePayInvoice(indexFinancialPendingSelected, true);
                }
                setShowModalPaymentMethodTicketConfirm(false);
            }} />
        </ContentForgot >
    );
}

export default Pending;
